import { AdaptCtaEntryPoint, AdaptDestinationArm } from '../../../constants/ab-tests/adapt-cta-destination';
import qualityEventsHelpers from '../quality-events.helpers';

// AB TEST - AI-1771
// Sent next to each entry point's MCP-1473 click event, which keeps its payload: `extra` there is the bare copy
// variant its analysis reads, and no other field it sends can hold the arm without changing type or meaning
export const ADAPT_CTA_QUALITY_EVENTS = {
    click(entryPoint: AdaptCtaEntryPoint, arm: AdaptDestinationArm) {
        qualityEventsHelpers.track({
            type: 'click_adapt_cta',
            extra: JSON.stringify({ entry_point: entryPoint, arm })
        });
    }
};
